module.exports = __webpack_public_path__ + "../front/img/768_3skuffer+trådhylde+hylder.ddb64d5e.svg";